import type {
  ClientMessage,
  SessionCredentials,
  UserLocation,
} from './protocol';
import type { PiChatStart } from './usePiChat';

export const sessionStartFrame = (
  {
    context,
    profile,
    capabilities,
    conversationId,
    newConversation,
    forkFrom,
    model,
    thinkingLevel,
  }: PiChatStart,
  credentials: SessionCredentials
): ClientMessage => {
  const conversation = conversationId
    ? { conversationId }
    : newConversation
      ? { newConversation }
      : forkFrom
        ? { forkFrom }
        : {};
  return {
    type: 'session.start',
    context,
    ...conversation,
    credentials,
    ...(model ? { model } : {}),
    ...(thinkingLevel ? { thinkingLevel } : {}),
    ...(capabilities?.length ? { capabilities: [...capabilities] } : {}),
    ...(profile ? { profile } : {}),
  };
};

export interface UserMessageFrameInput {
  text: string;
  clientMessageId: string;
  credentials: SessionCredentials;
  location?: UserLocation;
}

export const userMessageFrame = ({
  text,
  clientMessageId,
  credentials,
  location,
}: UserMessageFrameInput): ClientMessage => ({
  type: 'user.message',
  text,
  clientMessageId,
  credentials,
  ...(location ? { location } : {}),
});
